export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20top%20down%20arrangement%20of%20modern%20fashion%20essentials%20including%20textured%20sneakers%20canvas%20tote%20and%20folded%20garments%20on%20warm%20sandy%20surface%20with%20diffused%20afternoon%20sunlight%20and%20botanical%20shadows%2C%20editorial%20lifestyle%20photography%2C%20soft%20earthy%20tones%2C%20elegant%20minimalist%20composition%20with%20organic%20negative%20space&width=1800&height=900&seq=cta-v2-401&orientation=landscape"
        alt="CSSBuy Spreadsheet products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 text-center px-6 max-w-2xl mx-auto flex flex-col items-center">
        <h2 className="font-heading text-4xl md:text-6xl font-extrabold text-white tracking-wider uppercase leading-tight">
          CSSBUY SPREADSHEET
        </h2>
        <p className="text-white/80 text-base md:text-lg mt-4 max-w-md leading-relaxed">
          Acesse agora o spreadsheet mais completo e atualizado para comprar direto da China
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-3 bg-white text-foreground-950 px-8 py-4 rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap group"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span className="font-bold text-sm tracking-wide">BUY IT NOW</span>
          <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-foreground-600 transition-colors"></i>
        </a>
      </div>
    </section>
  );
}